import { render, staticRenderFns } from "./fromNow.vue?vue&type=template&id=5423e1db&scoped=true&"
import script from "./fromNow.vue?vue&type=script&lang=js&"
export * from "./fromNow.vue?vue&type=script&lang=js&"
import style0 from "./fromNow.vue?vue&type=style&index=0&id=5423e1db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423e1db",
  null
  
)

export default component.exports